import React, { useCallback } from 'react'
import { Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { ImportSpreadsheetModal, ImportSpreadsheetPanel } from '../import-spreadsheet-modal'
import {
  OFFICE_USERS_IMPORT_EXAMPLE,
  OFFICE_USERS_IMPORT_HEADERS,
  downloadXlsxTemplate,
} from '../../../lib/import-xlsx-template'
import type { ImportOfficeTarget, OfficeSelectOption } from '../../../lib/import-upload'
import { uploadOfficeUsers, USERS_IMPORT_COLUMN_HINTS } from '../../../lib/import-upload'

type Props = {
  officeOptions?: OfficeSelectOption[]
  fixedOffice?: ImportOfficeTarget
  fixedOfficeLabel?: string
  onImported?: () => void
  variant?: 'inline' | 'modal'
  buttonType?: 'default' | 'primary' | 'dashed' | 'link' | 'text'
  block?: boolean
  disabled?: boolean
}

export function ImportUsersBlock({
  officeOptions,
  fixedOffice,
  fixedOfficeLabel,
  onImported,
  variant = 'inline',
  buttonType = 'default',
  block = false,
  disabled = false,
}: Props) {
  const [open, setOpen] = React.useState(false)

  const downloadTemplate = useCallback(() => {
    downloadXlsxTemplate(
      'import-office-users.xlsx',
      OFFICE_USERS_IMPORT_HEADERS,
      OFFICE_USERS_IMPORT_EXAMPLE,
      'Сотрудники',
    )
  }, [])

  const panelProps = {
    columns: USERS_IMPORT_COLUMN_HINTS,
    onDownloadTemplate: downloadTemplate,
    officeOptions,
    fixedOffice,
    fixedOfficeLabel,
    emptyOfficeMessage: 'Нет офисов для импорта сотрудников',
    onSuccess: onImported,
    uploadRequest: (file: File, target: ImportOfficeTarget, onProgress: (percent: number) => void) =>
      uploadOfficeUsers(file, target.officeId, target.organizationId, onProgress),
  }

  if (variant === 'inline') {
    return <ImportSpreadsheetPanel {...panelProps} />
  }

  return (
    <>
      <Button
        type={buttonType}
        block={block}
        disabled={disabled}
        icon={<UploadOutlined />}
        onClick={() => setOpen(true)}
      >
        Импорт из Excel
      </Button>
      <ImportSpreadsheetModal
        open={open}
        title="Импорт сотрудников в офис"
        onClose={() => setOpen(false)}
        {...panelProps}
      />
    </>
  )
}

export default ImportUsersBlock
